module.exports = __webpack_public_path__ + "static/media/Seat Bump.141d999a.png";